// extracted by mini-css-extract-plugin
module.exports = {"blur":"IndentedComment-blur-2zZ84"};